import { useState } from "react";
import { Play, ExternalLink, X } from "lucide-react";
import { timeAgo } from "@/lib/utils";

export const VideoCard = ({ v, dark = false }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid={`video-card-${v.video_id}`} className={`group card-hover block w-full overflow-hidden rounded-xl border text-left shadow-sm ${dark ? "border-white/10 bg-white/5" : "border-slate-100 bg-white"}`}>
        <div className="img-zoom relative aspect-video overflow-hidden bg-slate-900">
          <img src={v.thumbnail} alt="" loading="lazy" className="h-full w-full object-cover" />
          <span className="absolute inset-0 grid place-items-center"><span className="grid h-12 w-12 place-items-center rounded-full bg-[#F5B301] text-[#0B1120] shadow-lg transition-transform group-hover:scale-110"><Play size={20} fill="currentColor" /></span></span>
        </div>
        <div className="p-3"><h4 className={`text-sm font-bold leading-snug line-clamp-2 ${dark ? "text-white group-hover:text-[#F5B301]" : "text-slate-900"}`}>{v.title}</h4><p className={`mt-1 text-xs ${dark ? "text-slate-400" : "text-slate-500"}`}>{v.channel} · {timeAgo(v.published_at)}</p></div>
      </button>
      {open && <VideoModal v={v} onClose={() => setOpen(false)} />}
    </>
  );
};

export const VideoModal = ({ v, onClose }) => (
  <div className="fixed inset-0 z-[100] grid place-items-center bg-black/85 p-4 backdrop-blur-sm" onClick={onClose} data-testid="video-modal">
    <div className="w-full max-w-4xl" onClick={(e) => e.stopPropagation()}>
      <div className="mb-3 flex items-start justify-between gap-4 text-white">
        <div><h3 className="font-display text-xl font-bold sm:text-2xl" data-testid="video-modal-title">{v.title}</h3><p className="text-xs text-slate-400">{v.channel} · {timeAgo(v.published_at)}</p></div>
        <button onClick={onClose} aria-label="Close" data-testid="video-modal-close" className="grid h-10 w-10 flex-none place-items-center rounded-full bg-white/10 hover:bg-white/20"><X size={18} /></button>
      </div>
      <div className="aspect-video overflow-hidden rounded-xl bg-black shadow-2xl">
        <iframe data-testid="video-modal-iframe" className="h-full w-full" src={`https://www.youtube-nocookie.com/embed/${v.video_id}?autoplay=1&rel=0`} title={v.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen referrerPolicy="strict-origin-when-cross-origin" />
      </div>
      <a href={v.source_url} target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-1 text-xs text-slate-300 hover:text-white" data-testid="video-modal-youtube-link">Watch on YouTube <ExternalLink size={11} /></a>
    </div>
  </div>
);
